import CoordinatorLink from './CoordinatorLink'

const DIGITAL_PORTFOLIO_URL = 'https://digitalportfolio.collegeboard.org/'

const mapStateToProps = state => {
  const {
    user: {
      data: { isCoordinator, isCSR },
    },
    status: {
      data: { examRegistrations },
    },
  } = state
  return {
    canAccess: isCoordinator && !isCSR,
    showLink: examRegistrations?.hasDpExams || examRegistrations?.hasApWeServiceSections,
  }
}

const DigitalPortfolioLink = ({ canAccess, showLink, description }) =>
  showLink ? (
    <CoordinatorLink
      linkName="Digital Portfolio"
      linkUrl={DIGITAL_PORTFOLIO_URL}
      disabled={!canAccess}
      description={description}
    />
  ) : null

export default connect(mapStateToProps)(DigitalPortfolioLink)
